export default __webpack_public_path__ + "static/hero_table-1b41bbddc9cdd4edff6b942d239fbcfa.png";